export default "__VITE_ASSET__aS2d9aEG__"